const Genesis = require("../Genesis.js")
import { Toast } from "bootstrap";
import { post } from "jquery";
import { WorkflowHandler } from "../Workflow/WorkflowHandler";
import { Modal } from "bootstrap";
import { BlockPageHelper, PreLoadHelper } from "../Helpers/helpers";
import Swal from "sweetalert2";
import { WOWorkflowActionNames } from "./WOWorkflowActionNames";
import { MapComponent } from '../Shared/GoogleMap/MapComponent';

export class ISiteMobileWorkOrderViewPage {
    private makeSafeToast: Toast = Toast.getOrCreateInstance("#makeSafeToast");
    private estimatedCostToast: Toast = Toast.getOrCreateInstance("#estimatedCostToast");
    private modal: Modal | null = null;
    private isActionsPopulated = false;
    private mapComponent: MapComponent = new MapComponent()

    public Init() {
        WorkflowHandler.InitWorkflowButtons();

        $(`.workflowActionButton[data-action='${WOWorkflowActionNames.ACTION_ConfirmRiskAssessmentPassed}']`).parent().hide();
        $(`.workflowActionButton[data-action='${WOWorkflowActionNames.ACTION_StartWorkRAPassed}']`).parent().hide();
        $(`.workflowActionButton[data-action='${WOWorkflowActionNames.ACTION_RiskAssessmentFailed}']`).parent().hide();
        $(`.workflowActionButton[data-action='${WOWorkflowActionNames.ACTION_StartWorkNoRA}']`).parent().hide();
        $(`.workflowActionButton[data-action='${WOWorkflowActionNames.ACTION_CancelWorkOrder}']`).parent().hide();
        $(`.workflowActionButton[data-action='${WOWorkflowActionNames.ACTION_CancelWorkOrderAndCloseSR}']`).parent().hide();

        $("#Item1_WorkOrderDetails_MakeSafe").change(() => {
            const recordId = $("#recordId").val() as number;
            post({
                url: Genesis.url('/WorkOrder/UpdateToggleField'),
                data:
                {
                    id: recordId,
                    isToggled: $("#Item1_WorkOrderDetails_MakeSafe").is(":checked"),
                    eToggleField: 'MakeSafe'
                }
            }).then(() =>
                this.makeSafeToast.show()
            );
        });

        $("#Item1_WorkOrderDetails_HealthAndSafetyIssue").change(() => {
            const recordId = $("#recordId").val() as number;
            post({
                url: Genesis.url('/WorkOrder/UpdateToggleField'),
                data:
                {
                    id: recordId,
                    isToggled: $("#Item1_WorkOrderDetails_HealthAndSafetyIssue").is(":checked"),
                    eToggleField: 'HealthAndSafetyIssue'
                }
            }).then(() =>
                this.makeSafeToast.show()
            );
        });

        $("#Item1_WorkOrderDetails_FollowOnWorkRequired").change(() => {
            const recordId = $("#recordId").val() as number;
            post({
                url: Genesis.url('/WorkOrder/UpdateToggleField'),
                data:
                {
                    id: recordId,
                    isToggled: $("#Item1_WorkOrderDetails_FollowOnWorkRequired").is(":checked"),
                    eToggleField: 'FollowOnWorkRequired'
                }
            }).then(() =>
                this.makeSafeToast.show()
            );
        });


        $("#btnUpdateCost").click((e: any) => {
            var estimatedCost = $("#Item1_WorkOrderDetails_CostEstimated").val();
            $("#Item1_WorkOrderDetails_CostEstimated").next().next().hide();

            if (!$.isNumeric(estimatedCost)) {
                $("#Item1_WorkOrderDetails_CostEstimated").addClass("invalid");
                $("#Item1_WorkOrderDetails_CostEstimated").next().next().text("Please enter a Valid Estimated Cost");
                $("#Item1_WorkOrderDetails_CostEstimated").next().next().show();
                return false;
            }
            const recordId = $("#recordId").val() as number;
            post({
                url: Genesis.url('/WorkOrder/UpdateEstimatedCost'),
                data:
                {
                    id: recordId,
                    estimatedCost: estimatedCost
                }
            }).then(() =>
                this.estimatedCostToast.show()
            );
        });

        this.mapComponent.initMap();

        $("#propertylink").click(function () {
            $('#propertylinklist').slideToggle('slow');
        });

        $("#assetlink").click(function () {
            $('#assetlinklist').slideToggle('slow');
        });
        $("#contactpersonlink").click(function () {
            $('#contactpersonlinklist').slideToggle('slow');
        });

        $("#affectedpersonlink").click(function () {
            $('#affectedpersonlinklist').slideToggle('slow');
        });

        $("#idEditPriority").click(function () {
            $('.priority-content').show();
        });
        $("#btnCancelUpdate").click(function () {
            $('.priority-content').hide();
        });

        $("#btnUpdatePriority").click(() => {
            const recordId = $("#recordId").val() as number;
            const priorityId = $("#Item1_WorkOrderDetails_PriorityID").val() as number;
            post({
                url: Genesis.url('/WorkOrder/UpdatePriority'),
                data:
                {
                    id: recordId,
                    priorityId: priorityId
                }
            }).then(() =>
                location.reload()
            );
        });

        $('.property-hazard-detail').each(function () {
            $(this).click(() =>
                post({
                    url: Genesis.url('/WorkOrder/GetPropertyHazards'),
                    data:
                    {
                        propertyId: $(this).data("propertyid"),
                        locationId: $(this).data("locationid")
                    }
                }).then((result) => {
                    const propertyhazardModal = document.getElementById('propertyHazardModal');
                    if (propertyhazardModal != null) {
                        $("#propertyhazard-content").html(result);
                        var modal = new Modal(propertyhazardModal, { backdrop: 'static', keyboard: false });
                        modal.show();
                    }
                })
            );
        });
    }
};